import React from "react";
import { useAuth } from "../../auth/AuthProvider.jsx";
import { useCarrier } from "./CarrierApp.jsx";
import { Shell, Back, Title, Section, NavCard, Button, C } from "./ui.jsx";

/**
 * Settings: the company's own admin area (the schematic's Settings board, Brian 2026-10-29). Admins
 * see every entry. Everyone else sees only how Alfred reaches them, and Rules when they may change
 * them.
 */
export const GROUPS = [
  { id: "reports", title: "Reports", items: [
    { to: "/carrier/settings/savings", title: "Savings", sub: "How much time and money Alfred saves you." },
    { to: "/carrier/settings/call-reports", title: "Call reports", sub: "What the calls show: activity, company standards and driver sentiment." },
    { to: "/carrier/settings/do-not-call", title: "Do Not Call (TCPA)", sub: "Who asked not to be called, and the calls Alfred held back." },
  ] },
  { id: "works", title: "How Alfred works", items: [
    { to: "/carrier/settings/rules", title: "Rules", sub: "What Alfred handles alone, when Alfred gets a person, and what you hear about.", rules: true },
    { to: "/carrier/settings/people", title: "People in the loop", sub: "Who Alfred hands things to, and how: warm transfer, email or text.", everyone: true },
  ] },
  { id: "account", title: "Your account", items: [
    { to: "/carrier/settings/access", title: "Admins and access", sub: "Who can sign in, and who can change rules." },
    { to: "/carrier/settings/billing", title: "Billing", sub: "Your plan, card and invoices." },
  ] },
];

/** The entries one person sees: all of them for an admin; otherwise their own and, if allowed, Rules. */
export function groupsFor(me) {
  if (me?.admin) return GROUPS;
  return GROUPS.map((g) => ({ ...g, items: g.items.filter((i) => i.everyone || (i.rules && me?.canChangeRules)) }))
    .filter((g) => g.items.length);
}

export function SettingsView({ company, stage, me, onSignOut }) {
  const groups = groupsFor(me);
  return (
    <Shell company={company} stage={stage} gap={28}>
      <Back to="/carrier">Home</Back>
      <Title sub={me?.admin ? "Admins see all of this. Everyone else sees only how Alfred reaches them." : "How Alfred reaches you."}>Settings</Title>
      {groups.map((g) => (
        <Section key={g.id} id={`settings-${g.id}`} title={g.title}>
          <nav aria-labelledby={`settings-${g.id}`} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16 }}>
            {g.items.map((i) => <NavCard key={i.to} to={i.to} title={i.title} sub={i.sub} />)}
          </nav>
        </Section>
      ))}
      {onSignOut && (
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", borderTop: `1px solid ${C.line}`, paddingTop: 20 }}>
          <span style={{ fontSize: 15, color: C.muted }}>Signed in as {me?.email}</span>
          <Button kind="secondary" onClick={onSignOut}>Sign out</Button>
        </div>
      )}
    </Shell>
  );
}

export default function SettingsHub() {
  const { carrier, me } = useCarrier();
  const { logout } = useAuth();
  return <SettingsView company={carrier.name} stage={carrier.stage} me={me} onSignOut={logout} />;
}
